import * as types from './mutation-types';
import initialState from './state';

export default {
    [types.SET_VIEW](state, view) { state.currentView = view; },
    [types.SET_LOADING](state, val) { state.loading = val; },
    [types.SET_LOADING_SET_AGREEMENT](state, val) { state.loadingSetAgreement = val; },
    [types.SET_LOADING_DUE_DATE](state, val) { state.loadingDueDate = val; },
    [types.SET_LOADING_DASHBOARD_DEBTS](state, val) { state.loadingDashboardDebts = val; },
    [types.SET_NOT_LOGGED_TEXT](state, text) { state.notLoggedText = text; },

    [types.SET_DOC_NUMBER](state, val) { state.docNumber = val; },
    [types.SET_DEBTOR_ID](state, val) { state.debtorId = val; },
    [types.SET_IP_USER](state, val) { state.ipUser = val; },
    [types.SET_USER_ADM_ID](state, val) { state.userAdmId = val; },
    [types.SET_CLIENT_ID_BOTICARIO](state, val) { state.clientIdBoticario = val; },
    [types.SET_CLIENT_ID_EUDORA](state, val) { state.clientIdEudora = val; },

    [types.SET_DEBTS_BOTICARIO](state, val) { state.debtsBoticario = val; },
    [types.SET_DEBTS_EUDORA](state, val) { state.debtsEudora = val; },
    [types.SET_OFFERS_BOTICARIO](state, val) { state.offersBoticario = val; },
    [types.SET_OFFERS_EUDORA](state, val) { state.offersEudora = val; },
    [types.SET_OFFERS_NEGOTIATION_BOTICARIO](state, val) { state.offersBoticarioNegotiation = val; },
    [types.SET_OFFERS_NEGOTIATION_EUDORA](state, val) { state.offersEudoraNegotiation = val; },
    [types.SET_MAIN_OFFERS_BOTICARIO](state, val) { state.mainOffersBoticario = val; },
    [types.SET_MAIN_OFFERS_EUDORA](state, val) { state.mainOffersEudora = val; },
    [types.SET_SELECTED_OFFER_BOTICARIO](state, val) { state.selectedOfferBoticario = val; },
    [types.SET_SELECTED_OFFER_EUDORA](state, val) { state.selectedOfferEudora = val; },

    [types.SET_DEBT_BOTICARIO](state, val) { state.debtBoticario = val; },
    [types.SET_LATE_DATE_BOTICARIO](state, val) { state.lateDateBoticario = val; },
    [types.SET_LATE_DATE_EUDORA](state, val) { state.lateDateEudora = val; },
    [types.SET_DUE_DATE_BOTICARIO](state, val) { state.dueDateBoticario = val; },
    [types.SET_DUE_DATE_EUDORA](state, val) { state.dueDateEudora = val; },
    [types.SET_DUE_DATES_BOTICARIO](state, val) { state.dueDatesBoticario = val; },
    [types.SET_DUE_DATES_EUDORA](state, val) { state.dueDatesEudora = val; },

    [types.SET_PREVENTIVE_BOTICARIO](state, val) { state.preventiveBoticario = val; },
    [types.SET_PREVENTIVE_EUDORA](state, val) { state.preventiveEudora = val; },
    [types.SET_HAS_AGREEMENT_BOTICARIO](state, val) { state.hasAgreementBoticario = val; },
    [types.SET_HAS_AGREEMENT_EUDORA](state, val) { state.hasAgreementEudora = val; },
    [types.SET_HAS_NO_BOTICARIO_DATA](state, val) { state.hasNoBoticarioData = val; },
    [types.SET_HAS_NO_EUDORA_DATA](state, val) { state.hasNoEudoraData = val; },
    [types.ADD_VIEWED_OFFERS_BOTICARIO_LOG_KEY](state, key) {
        if (!state.viewedOffersBoticarioLogKeys.includes(key)) {
            state.viewedOffersBoticarioLogKeys.push(key);
        }
    },
    [types.ADD_VIEWED_OFFERS_EUDORA_LOG_KEY](state, key) {
        if (!state.viewedOffersEudoraLogKeys.includes(key)) {
            state.viewedOffersEudoraLogKeys.push(key);
        }
    },

    [types.SET_AGREEMENT](state, val) { state.agreement = val; },
    [types.SET_PREPARE_AGREEMENT](state, val) { state.prepareToSetAgreement = val; },
    [types.SET_SELECTED_PAYMENT_METHOD](state, val) { state.selectedPaymentMethod = val; },

    [types.SET_LOADING_AGREEMENT_BILL](state, key) {
        if (key == null || key === false || key === '') {
            state.loadingAgreementBillKey = null;
        } else {
            state.loadingAgreementBillKey = String(key);
        }
    },

    [types.SET_AGREEMENT_BILL_SCREEN](state, payload) {
        state.agreementBillBrand = payload.brand;
        state.agreementBillContextItem = payload.contextItem;
        state.agreementBillRawInner = payload.rawInner;
        state.agreementBillOptions = Array.isArray(payload.options) ? payload.options : [];
        state.agreementBillSelectedOptionIndex = typeof payload.selectedIndex === 'number'
            ? payload.selectedIndex
            : 0;
    },

    [types.SET_AGREEMENT_BILL_SELECTED_OPTION](state, index) {
        state.agreementBillSelectedOptionIndex = index;
    },

    [types.CLEAR_AGREEMENT_BILL_SCREEN](state) {
        state.agreementBillBrand = null;
        state.agreementBillContextItem = null;
        state.agreementBillRawInner = null;
        state.agreementBillOptions = [];
        state.agreementBillSelectedOptionIndex = 0;
        state.loadingAgreementBillKey = null;
    },

    [types.RESET_NEGOTIATION_FLOW](state) {
        state.agreement = null;
        state.prepareToSetAgreement = null;
        state.selectedPaymentMethod = null;
        state.debtBoticario = null;
        state.offersBoticarioNegotiation = [];
        state.offersEudoraNegotiation = [];
        state.mainOffersBoticario = [];
        state.mainOffersEudora = [];
        state.selectedOfferBoticario = null;
        state.selectedOfferEudora = null;
        state.loadingDueDate = false;
        state.loadingSetAgreement = false;
        // Preserva dueDate*/dueDates*/lateDate* — esses valores ficam estáveis
        // até o próximo getDebts (que rebuilda) e evita ficar em branco ao
        // re-entrar na tela de negociação sem refetch.
        state.currentView = 'dashboard';
        state.loadingAgreementBillKey = null;
        state.agreementBillBrand = null;
        state.agreementBillContextItem = null;
        state.agreementBillRawInner = null;
        state.agreementBillOptions = [];
        state.agreementBillSelectedOptionIndex = 0;
    },

    /** Logout: volta o slice ao estado inicial (evita “cache” de ofertas/acordo na memória). */
    [types.RESET_NEGOTIATION_SESSION](state) {
        const defaults = JSON.parse(JSON.stringify(initialState));
        Object.keys(defaults).forEach((k) => {
            state[k] = defaults[k];
        });
    },
}
